export const userRoleAdmin = 'ADMIN'
export const userRoleSupervisor = 'SUPERVISOR'
export const userRoleUser = 'USER'
export const userRoleSuperUser = 'SUPER USER'

export const sideBarEvent = 'sideBarEvent'
export const sideBarEventUrlClicked = 'sideBarEventUrlClicked'

export const jobId = 'JobId'
export const jobStatus = 'JobStatus'
export const box = 'Box'
export const boxComplete = 'BoxComplete'
export const district = 'District'
export const targetCompletiondateFrom = 'TargetCompletiondateFrom'
export const targetCompletiondateTo = 'TargetCompletiondateTo'
export const TemplateType = 'TemplateType'
export const TemplateName = 'TemplateName'
export const ROW_SELECTED = 'rowSelected'
export const wms = 'wms'
export const country = 'country'
export const dateCreated = 'dateCreated'
export const customerIdName = 'customerIdName'
export const createdBy = 'createdBy'
export const districtName = 'districtName'
export const pickupDataFrom = 'pickupDataFrom'
export const pickupDataTo = 'pickupDataTo'

export const userTypes = {
  DATAENTRY_AND_VERIFY_USER: 'DATAENTRY_AND_VERIFY_USER',
  VERIFICATION_USER: 'VERIFICATION_USER',
  DATAENTRY_USER: 'DATAENTRY_USER'
}

export const iKeyCode = 73

export const defaultDateFormat = 'MM/DD/YYYY'
// default date for all countries except us and canada on create template and create job screens
export const defaultDateFormat2 = 'DD/MM/YYYY'

// AI code start — QC DataGrid layout constants
export const QC_GRID_DEFAULT_PAGE_SIZE = 20
export const QC_GRID_PAGE_SIZE_OPTIONS = [20, 50, 100]
export const QC_GRID_ROW_BUFFER = 10
export const QC_GRID_MIN_VISIBLE_ROWS = 10
export const QC_GRID_VIEW_ROW_HEIGHT = 40
export const QC_GRID_EDIT_ROW_BASE_HEIGHT = 58
export const QC_GRID_ERROR_LINE_HEIGHT = 18
export const QC_GRID_ERROR_CHARS_PER_LINE = 14
export const QC_GRID_ERROR_ROW_PADDING = 12
export const QC_GRID_HEADER_HEIGHT = 56
export const QC_GRID_TOOLBAR_HEIGHT = 32
export const QC_GRID_FOOTER_HEIGHT = 48
export const QC_GRID_DEFAULT_HEIGHT = 500
// AI code end

export const QC_BOX_ROWS_BUILD_BATCH = 500
// Characters and equivalent regex pattern - Format required
export const formatPatterns = {
  '#': '[0-9]',
  A: '[0-9 a-z A-Z]',
  a: '[0-9 a-z A-Z]?',
  9: '[0-9]?',
  '.': '.',
  ',': ',',
  '/': '/',
  ':': ':',
  '-': '-',
}
export const optionalFormatPattern = ['a', 9]

export const invalidDate = '-'

export const countryConfig = [{ countryCode: 'us', dateFormat: 'MM/DD/YYYY' }, { countryCode: 'ca', dateFormat: 'MM/DD/YYYY' }]

export const constantVersion = 'R55'








